<template>
  <div class="parentswiper group_sw">
    <div class="wrapperswiper">
      <div class="artdatalist" id="content">
        <div class="childnode" id="scrollObiect">
          <ul id="ulwidth">
            <li v-for="item in artSchoolList" :key="item.id" class="liwidth" :data-id="item.id">
              <div class="arthead">
                <router-link target="_blank" :to="'/subjectdetail/' + item.id">
                  <strong
                    style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                  >{{item.title}}</strong>
                </router-link>
                <a
                  class="commstyles"
                  @click="Join(item)"
                  v-bind:class="{gzstyle: item.isFollow==1}"
                >{{!item.isFollow?$t('global.关注'):$t('global.已关注')}}</a>
              </div>

              <div class="parentvideolist">
                <div
                  class="artvideolistparent"
                  v-for="itemChild in item.videoDomainPageList.list"
                  :key="itemChild.videoId"
                >
                  <router-link
                    class="artvideolist"
                    :to="'/video/detail?id='+itemChild.videoId"
                    target="_blank"
                  >
                    <img
                      class="artThumb"
                      style="position:absolute;z-index: 0"
                      :src="itemChild.thumb | imageUrl('',520,292)"
                    >
                    <div
                      style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
                      class="artTitle"
                    >{{itemChild.title}}</div>
                    <img class="artAvatar" :src="itemChild.avatar | imageUrl('/static/profile_img_default.png',40,40)">
                    <span class="artnickname">{{itemChild.nickName}}</span>
                    <span class="artTimes">{{itemChild.duration | secondToDate}}</span>
                    <div class="opacitylayout"></div>
                  </router-link>
                </div>
              </div>

              <router-link
                class="commstyles allworks"
                target="_blank"
                :to="`/subjectdetail?id=${item.id}&page=1`"
              >{{$t('global.全部作品')}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--prev btn-->
    <img
      id="scrollPrev"
      v-if="showNext"
      @click="domPrev"
      class="swiperbutton-prev"
      src="/static/artprev.png"
    >
    <!--next btn-->
    <img
      id="scrollNext"
      v-if="showNext"
      @click="domNext"
      class="swiperbutton-next"
      src="/static/artnext.png"
    >
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import log from "../../util/log";

export default {
  name: "",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    page_size: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      flag: true,
      isLoad: true,
      showNext: true,
      //得到父级数据
      swiperSlideList: [],
      videoList: [],
      svgShowBox1: false,
      svgShowBox2: true,
      pagerParam: {
        pageSize: 5,
        pageCount: 1,
        currentPage: 1,
        total: 1,
        hasNextPage: false,
        hasPrePage: false
      },
      artSchoolList: [],
      isPreState: false,
      isNextState: false,
      busy: false,
      swiperOptions: {
        navigation: {
          nextEl: "#sqsvg1",
          prevEl: "#sqsvg"
        }
      }
    };
  },
  created() {
    this.getArtSchoolList();
  },
  watch: {
    artSchoolList(val) {
      this.$emit("update-item-list", { list: val });
    }
  },
  mounted() {},

  methods: {
    domPrev() {
      let liw = document.getElementsByClassName("liwidth")[0].offsetWidth + 7;
      let obj = document.getElementById("scrollObiect").offsetWidth;
      const scrollLeft = document.getElementById("scrollObiect").scrollLeft;
      const num = Math.floor(obj / liw);
      const num1 = Math.floor(scrollLeft / liw);
      if (this.flag) {
        this.$scrollTo(
          document.getElementById("scrollObiect"),
          scrollLeft,
          (num1 - num) * liw,
          1
        );
        this.flag = false;
        setTimeout(() => {
          this.flag = true;
        }, 1000);
      }
    },
    domNext() {
      let liw = document.getElementsByClassName("liwidth")[0].offsetWidth + 7;
      let obj = document.getElementById("scrollObiect").offsetWidth;
      const scrollLeft = document.getElementById("scrollObiect").scrollLeft;
      const num = Math.floor(obj / liw);
      const num1 = Math.floor(scrollLeft / liw);
      if (this.flag) {
        this.$scrollTo(
          document.getElementById("scrollObiect"),
          scrollLeft,
          (num1 + num) * liw,
          1
        );
        this.flag = false;
        setTimeout(() => {
          this.flag = true;
        }, 1000);
      }
    },
    getArtSchoolList() {
      let $this = this;
      let topicIds = [83, 105, 104, 99].join();
      this.$http
        .get(
          "/api/topic/findPageList?topicIds=" +
            topicIds +
            "&orderBy=0&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=5"
        )
        .then(function(response) {
          $this.artSchoolList = $this.artSchoolList.concat(response.data.list);
          //debugger
          var data = response.data;
          $this.pagerParam = {
            pageSize: data.pageSize,
            pageCount: data.totalPage,
            currentPage: data.pageIndex,
            total: data.totalRecord,
            hasNextPage: data.hasNextPage
          };
          $this.addNext();
        });
    },

    addNext() {
      if (this.pagerParam.hasNextPage) {
        this.pagerParam.currentPage = this.pagerParam.currentPage + 1;
        this.getArtSchoolList();
      } else {
        setTimeout(() => {
          const width = document.getElementById("ulwidth").offsetWidth;
          let scrollWidth = document.getElementById("scrollObiect").offsetWidth;
          if (width > scrollWidth) {
            this.showNext = true;
          } else {
            this.showNext = false;
          }
        });
      }
    },
  
    Join(item) {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(`/login?redirecturl=${window.location}`);
        return;
      }
      var $this = this;
      if (item.isFollow) {
        this.$confirm(`${this.$t('global.是否取消关注')}?`, this.$t('global.提示'), {
          confirmButtonText: this.$t('global.确定'),
          cancelButtonText: this.$t('global.取消'),
          type: "warning"
        })
          .then(() => {
            $this.$http
              .post("/api/u/topic/leave", {
                topicId: item.id
              })
              .then(function(response) {
                if (response.code === "OK") {
                  $this.$message({
                    message: $this.$t('global.离开成功'),
                    type: "success",
                    duration: 2000
                  });
                  item.isFollow = false;
                }
              });
          })
          .catch(() => {});
      } else if (!item.isFollow) {
        this.$http
          .post("/api/u/topic/join", {
            topicId: item.id
          })
          .then(function(response) {
            if (response.code === "OK") {
              $this.$message({
                message: $this.$t('global.加入成功'),
                type: "success",
                duration: 2000
              });
              item.isFollow = true;
            }
          });
      }
    }
  }
};
</script>

<style scoped>
.wrapperswiper {
  position: relative;
  height: calc(100vh - 167px);
  width: 100vw;
  overflow-x: auto !important;
  overflow-y: hidden;
  min-width: 100vw;
}
.wrapperswiper .swiperbutton-prev {
  left: -40px;
}
.wrapperswiper .swiperbutton-next {
  right: -50px;
}
.parentvideolist {
  width: 330px;
}

.svgshowbox1 {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 11;
  right: -50px;
}
.svgshowbox2 {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 11;
  left: -40px;
}
.swiperbutton-prev {
  left: -40px;
}
.swiperbutton-next {
  right: -50px;
}

/*  artdatalist */
.childnode {
  float: left;
  width: 100vw;
  height: calc(100vh - 167px);
  overflow: hidden;
  overflow-x: scroll;
  transition: all 0.5s ease;
}
.childnode ul {
  float: left;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 100vw;
  justify-content: center;
}

.artdatalist {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
}
.artdatalist li {
  /* float: left; */
  width: 330px;
  margin-right: 7px;
  height: calc(100vh - 167px);
  overflow-y: scroll;
  box-sizing: border-box;
}

.artdatalist li::-webkit-scrollbar {
  width: 0 !important;
}
.artdatalist li {
  -ms-overflow-style: none;
}
.artdatalist li {
  overflow: -moz-scrollbars-none;
}
.artdatalist li:nth-child(2n) {
  background-color: #f8f8f8;
}

.artdatalist li .arthead {
  text-align: center;
  padding-top: 55px;
}
.artdatalist li .arthead strong {
  display: block;
  color: #7d7d7d;
  font-size: 18px;
  height: 45px;
  overflow: hidden;
  line-height: 23px;
  padding: 0 10px;
  text-overflow: ellipsis;
}
.artdatalist li:hover .arthead a strong {
  color: #333;
  cursor: pointer;
}
.artdatalist li .arthead p {
  color: #7d7d7d;
  font-size: 14px;
}
a.commstyles {
  display: block;
  width: 80px;
  height: 30px;
  color: #fff;
  margin: 15px auto 0;
  line-height: 30px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #3664ed;
  box-sizing: border-box;
}
a.gzstyle {
  color: #333;
  border: 1px solid #333;
  background-color: transparent;
}

a.allworks {
  color: #333;
  text-align: center;
  margin: 55px auto 70px;
  border: 1px solid #333;
  background-color: transparent;
}
a.allworks:hover {
  color: #3664ed;
  border: 1px solid #3664ed;
}
.artvideolist {
  position: relative;
  display: block;
  height: 146px;
  width: 260px;
  margin: 40px 35px 0;
}
.artvideolist .artThumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.artTimes {
  position: absolute;
  padding: 1px 7px;
  right: 5px;
  bottom: 3px;
  border-radius: 3px;
  z-index: 10;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.7);
}
.artTitle {
  position: absolute;
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  top: 50%;
  left: 0;
  height: 40px;
  overflow: hidden;
  text-align: center;
  z-index: 10;
  transform: translate(0, -50%);
  opacity: 0;
}
.artvideolist .artAvatar {
  position: absolute;
  left: 5px;
  bottom: 3px;
  width: 20px;
  height: 20px;
  z-index: 10;
  border-radius: 10px;
  opacity: 0;
}
.artnickname {
  position: absolute;
  left: 30px;
  bottom: 5px;
  display: inline-block;
  width: 80px;
  font-size: 12px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0;
  z-index: 10;
}
.opacitylayout {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  z-index: 9;
  background: rgba(0, 0, 0, 0.4);
}
.artvideolist:hover .artTitle,
.artvideolist:hover .artAvatar,
.artvideolist:hover .artnickname {
  opacity: 1;
}
.artvideolist:hover .opacitylayout {
  display: block;
}
.swiperbutton-prev {
  position: fixed;
  top: 50%;
  width: 70px;
  height: 70px;
  margin-top: -35px;
  left: 10px !important;
  z-index: 999;
}
.swiperbutton-next {
  position: fixed;
  top: 50%;
  width: 70px;
  height: 70px;
  margin-top: -35px;
  right: 10px !important;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/list/swp_school_group.vue